import { api, unwrap } from './client';

export async function getNotifications({ page = 0, size = 10, type = null } = {}) {
  try {
    let url = `/notifications?page=${page}&size=${size}`;
    if (type && type !== 'ALL') {
      url = `/notifications/type/${type}?page=${page}&size=${size}`;
    }
    const res = await api.get(url);
    return unwrap(res);
  } catch (err) {
    return { content: [], totalElements: 0, totalPages: 0 };
  }
}

export async function getUnreadNotifications({ page = 0, size = 10 } = {}) {
  try {
    const res = await api.get(`/notifications/unread?page=${page}&size=${size}`);
    return unwrap(res);
  } catch (err) {
    return { content: [], totalElements: 0, totalPages: 0 };
  }
}

export async function getUnreadCount() {
  try {
    const res = await api.get('/notifications/unread/count');
    return unwrap(res);
  } catch (err) {
    return { unreadCount: 0, hasUnread: false };
  }
}

export async function markAsRead(id) {
  try {
    const res = await api.put(`/notifications/${id}/read`);
    return unwrap(res);
  } catch (err) {
    return null;
  }
}

export async function markAsUnread(id) {
  try {
    const res = await api.put(`/notifications/${id}/unread`);
    return unwrap(res);
  } catch (err) {
    return null;
  }
}

export async function markAllAsRead() {
  try {
    const res = await api.put('/notifications/read-all');
    return unwrap(res);
  } catch (err) {
    return null;
  }
}

export async function deleteNotification(id) {
  try {
    const res = await api.delete(`/notifications/${id}`);
    return unwrap(res);
  } catch (err) {
    return null;
  }
}
